import { type IconProps, defaultProps } from './IconProps'

interface InfoIconProps extends IconProps {
  filled: boolean
}

export const InfoIcon = (props: InfoIconProps) => {
  return props.filled ? (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 15.5C12.6421 15.5 16 12.1421 16 8C16 3.85786 12.6421 0.5 8.5 0.5C4.35786 0.5 1 3.85786 1 8C1 12.1421 4.35786 15.5 8.5 15.5ZM8.5 7.5C8.77614 7.5 9 7.72386 9 8V12.2187C9 12.4949 8.77614 12.7187 8.5 12.7187C8.22386 12.7187 8 12.4949 8 12.2187V8C8 7.72386 8.22386 7.5 8.5 7.5ZM9.69932 5.2C9.69932 5.86274 9.16206 6.4 8.49932 6.4C7.83658 6.4 7.29932 5.86274 7.29932 5.2C7.29932 4.53726 7.83658 4 8.49932 4C9.16206 4 9.69932 4.53726 9.69932 5.2Z"
        fill={props.colour}
      />
    </svg>
  ) : (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 12.2187V8M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z"
        stroke={props.colour}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99932 6.4C8.66206 6.4 9.19932 5.86274 9.19932 5.2C9.19932 4.53726 8.66206 4 7.99932 4C7.33657 4 6.79932 4.53726 6.79932 5.2C6.79932 5.86274 7.33657 6.4 7.99932 6.4Z"
        fill={props.colour}
      />
    </svg>
  )
}
InfoIcon.defaultProps = { ...defaultProps, filled: false }
